import React, { useMemo } from 'react';
import { AUTH_TOKEN_KEY } from '../../../../constants';
import api from '../../../../utils/Api';
import debounce from 'debounce-promise';
import Select from 'react-select';

const SelectRarity = (props) => {
  const { value, onChange, ...rest } = props;
  const myToken = useMemo(() => localStorage.getItem(AUTH_TOKEN_KEY), []);
  const headers = useMemo(() => ({ 'Authorization': `Bearer ${myToken}` }), [myToken]);

  const _getRarityOptions = (input) => {
    const params = { keyword: input };
    return api(headers).get('/admins/rarities', { params })
      .then(({ data }) => ({
        options: data.data.map(item => ({ id: item.id, name: item.name }))
      }));
  };

  const getRarityOptions = debounce(_getRarityOptions, 300);

  return (
    <Select.Async
      valueKey="id"
      labelKey="name"
      loadOptions={getRarityOptions}
      onChange={onChange}
      value={value}
      placeholder="Select a rarity..."
      noResultsText="No rarity found."
      {...rest}
    />
  );
};

export default SelectRarity;
